/** The DOM id a `TabBar` tab gets when the bar is given an `idPrefix`. */
export function tabBarTabId(idPrefix: string, value: string): string {
  return `${idPrefix}-tab-${value}`;
}
